import React from 'react';
import mPaper from '@material-ui/core/Paper';
import mTypography from '@material-ui/core/Typography';
import MButton from '@material-ui/core/Button';
import styled from 'styled-components';

export const Paper = styled(mPaper)`
  display: flex;
  flex-direction: column;
  padding: 40px;
  width: 700px;
`;

export const Typography = styled(mTypography)`
  text-align: center;
  font-size: 25px !important;
  font-weight: bold !important;
`;

export const TypographyBody = styled(mTypography)`
  text-align: center;
  font-size: 20px !important;
`;

export const Button = ({ ...props }) => (
  <MButton variant="outlined" style={{ marginTop: '20px' }} {...props} />
);
